// src/lib/cache/expenseCategories.js
//
// Per-entity cache wiring for expense_categories. listExpenseCategories
// resolves its own companyId, so the fetcher ignores the companyId arg.

import {
  listExpenseCategories,
  createExpenseCategory,
  updateExpenseCategory,
  deleteExpenseCategory,
} from '../api/financial/expenseManagement.js'
import {
  useEntityListQuery,
  useOptimisticListMutation,
  useStandardDeleteMutation,
  defaultCreateReconcile,
  defaultUpdateReconcile,
  unwrapList,
} from './entityCache.js'

const ENTITY = 'expense_categories'

const buildCreatePlaceholder = (vars, tempId) => ({
  ...vars,
  id: tempId,
})

export const useExpenseCategoriesQuery = () =>
  useEntityListQuery(ENTITY, unwrapList('expense categories', () => listExpenseCategories()))

export const useCreateExpenseCategoryMutation = () =>
  useOptimisticListMutation(ENTITY, {
    mutationFn: (categoryData) => createExpenseCategory(categoryData),
    applyOptimistic: (prev, vars, { tempId }) => [
      buildCreatePlaceholder(vars, tempId),
      ...prev,
    ],
    reconcile: defaultCreateReconcile,
  })

export const useUpdateExpenseCategoryMutation = () =>
  useOptimisticListMutation(ENTITY, {
    mutationFn: ({ id, ...patch }) => updateExpenseCategory(id, patch),
    applyOptimistic: (prev, vars) =>
      prev.map((row) => (row.id === vars.id ? { ...row, ...vars } : row)),
    reconcile: defaultUpdateReconcile,
  })

export const useDeleteExpenseCategoryMutation = () =>
  useStandardDeleteMutation(ENTITY, deleteExpenseCategory)
